import { setTerms } from './helpers';

export const setRegionId = setTerms('region');
